module.exports = __webpack_public_path__ + "Kaitak_FV_200813seizou.05a273730a22fa2b1c94.png";